import React from "react";
import { useSelector } from "react-redux";
import get from "lodash/get";
import { Link } from "@quintype/components";
import { useTrackWidgetImpression, trackCtaClick } from "../../../ga-utils";
import { Button } from "../../atoms";
import { useDeviceType } from "../../customHooks/useDeviceType";

import "./EMagazineWidgetBanner.m.css";

const EMagazineWidgetBanner = (props) => {
  const {
    data: { magazineWidget },
  } = props;
  const { emagazineLink } = magazineWidget;
  const deviceType = useDeviceType();
  const isDesktop = deviceType === "desktop";
  const {
    emagazineMainContainerBgImageUrl,
    emagazineDesktopBgImageUrl,
    emagazineMobileBgImageUrl,
    emagazineDesktopDescription1,
    emagazineDesktopDescription2,
    emagazineMobileDescription,
    readEMagazine,
  } = magazineWidget;

  const pageType = useSelector((state) => get(state, ["qt", "pageType"], {}));

  const isBrowser = typeof window !== "undefined";

  // Use the custom hook for tracking widget impressions
  const componentRef = useTrackWidgetImpression(
    {
      sectionName: "E-Magazine",
      pageType: pageType,
      location: isBrowser ? window.location : null,
      config: {},
      threshold: 0.2,
    },
    { disabled: !isBrowser }
  );

  const trackEvent = () => {
    if (typeof window === "undefined") return;

    try {
      trackCtaClick({
        linkText: readEMagazine,
        linkUrl: emagazineLink,
        pageType: pageType,
        location: window.location,
      });
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <div
      style={{ backgroundImage: `url(${emagazineMainContainerBgImageUrl})` }}
      styleName="magazine-main-container"
      ref={componentRef}
    >
      <div styleName="magazine-content-wrapper">
        {isDesktop ? (
          <>
            <div style={{ backgroundImage: `url(${emagazineDesktopBgImageUrl})` }} styleName="e-magazine-image"></div>
            <div styleName="magazine-text-content">
              <div>
                <span>{emagazineDesktopDescription1}</span> <br />
                <span>{emagazineDesktopDescription2}</span>
              </div>
              <Link href={emagazineLink} onMouseDown={trackEvent}>
                <Button customStyleName="read-emagazine-button">{readEMagazine}</Button>
              </Link>
            </div>
          </>
        ) : (
          <>
            <div
              style={{ backgroundImage: `url(${emagazineMobileBgImageUrl})` }}
              styleName="e-magazine-image-mobile"
            ></div>
            <div styleName="magazine-text-content-mobile">
              <span>{emagazineMobileDescription}</span>
              <a href={emagazineLink} target="_blank" rel="noopener noreferrer">
                <Button customStyleName="read-emagazine-button">{readEMagazine}</Button>
              </a>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default EMagazineWidgetBanner;
